import { MenuItem } from '@mui/material'
import { ActionsItemProps } from './actions'
import SimCardDownloadIcon from '@mui/icons-material/SimCardDownload'
import { useNfeModalStore } from 'modules/orders/components/NfeModal/NfeModalStore'

export const NFEDownload = ({ order, disabled }: ActionsItemProps) => {
  const setOrderId = useNfeModalStore.useSetOrderId()
  const setOpen = useNfeModalStore.useSetModalIsOpen()

  const handleClick = () => {
    setOpen(true)
    setOrderId(order?.orderId)
  }

  return (
    <MenuItem onClick={handleClick} disabled={disabled}>
      <SimCardDownloadIcon />
      Baixar Nfe
    </MenuItem>
  )
}
